import { Link } from "react-router-dom";
import { CalendarCheck, Info } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { SectionHead } from "../components/SectionHead";
import { Reveal } from "../components/motion";
import { RetinaServices } from "../components/RetinaServices";

const Retina = () => (
  <>
    <PageHero
      kicker="Retina Specialist in Janak Puri, Delhi"
      testid="retina-hero"
      lines={[
        <>Advanced</>,
        <>
          <span className="font-serif italic font-semibold text-brand-bright">retina</span> care.
        </>,
      ]}
      sub="Comprehensive diagnosis and treatment for complex retinal conditions — from diabetic eye disease to retinal detachment."
    />

    <section className="py-20 sm:py-28" data-testid="retina-categories-section">
      <div className="container-x max-w-5xl">
        <SectionHead
          chapter="01"
          kicker="Treatments"
          title="Retina services at iNetra"
          sub="Three pillars of retinal care — surgery, injection therapy and laser — explained simply, recommended honestly."
        />
        <div className="mt-12">
          <RetinaServices />
        </div>
        <Reveal delay={0.1} className="mt-10">
          <div className="rounded-2xl border border-aqua/25 bg-aqua-mist p-6 flex gap-4" data-testid="retina-note">
            <Info className="w-5 h-5 text-aqua shrink-0 mt-0.5" aria-hidden="true" />
            <p className="text-sm text-slate-700 leading-relaxed">
              Many retinal conditions — especially diabetic retinopathy — cause no early symptoms. If you have
              diabetes, high myopia, or a family history of retinal disease, a periodic retina evaluation is the
              safest way to protect your sight. Early detection allows simpler, more effective treatment.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 text-center">
          <Link to="/contact#book" className="btn-primary" data-testid="retina-book-button">
            <CalendarCheck className="w-4 h-4" aria-hidden="true" /> Book a Retina Consultation
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export default Retina;
